const Form004EN = {
    stepName: {
        statement: "Statement",
        basicInformation: "Basic Information of Project",
        activitiesHeldWithSchool:
            "Activities Held With Collaborating School(s)",
        activitiesOpenToCommunity: "Activities Open To The Community",
        total: "Total",
        confirmation: "Confirmation",
    },
    statement: {
        tips1: "1. All information of the e-Form contained herein shall be subject to the application form on the EDB website",
        tipsUrl:
            "https://www.edb.gov.hk/en/student-parents/support-subsidies/after-sch-learning-support-program/community-based-projects/index.html",
        tips2: "2. School-based After-school Learning and Support Programmes Community-based Project - Operation Status Report (up to 15 October of the school year) (This form, duly completed and signed, should be returned to the Student Special Support Section of EDB on or before 31 October of the school year)",
    },
    button: {
        addActivity: "ADD ACTIVITY",
        removeActivity: "REMOVE ACTIVITY",
        addSchool: "ADD COLLABORATING SCHOOL",
        removeSchool: "REMOVE COLLABORATING SCHOOL",
    },
    label: {
        statement: "Statement",
        statementCheck:
            "I have read, understood and agreed to the above terms and conditions",
        basicInformation: "Basic Information",
        organisationName: "Name of Organisation",
        projectTitle: "Project Title",
        applicationRefNO: "Project Ref. No.",
        projectCoordinator: "Project Coordinator",
        contactPerson: "Contact Person",
        contactTelNo: "Contact Tel. No.",
        tips: "Please provide information on all approved activities",
        activitiesSchool:
            "(I) Activities Held with Collaborating School(s) (List out all the approved activities)",
        ngoChopFile: "NGO's/ Department's / Subsidiary Organisation's chop",
        approvedProject: "Information on Approved Project:",
        activityName: "Name of activity",
        schoolName: "Name of collaborating school",
        actualSituation: "Actual Situation:",
        actualSituationOption: {
            completed: "Completed",
            inProgress: "In progress",
            notCommenced: "Not yet commenced",
            cancelled: "To be cancelled",
            adjustment: "Adjustment required",
        },
        selectContent: "Please provide information on all approved activities:",
        other: "Other",
        stepOption: {
            ActivitiesHeldWithSchool:
                "Activities held with collaborating school(s)",
            ActivitiesOpenToCommunity: "Activities open to the community",
        },
        remark: "Remark",
        remarkEg:
            "E.g. indicating activity dates: Every Mon, Wed and Fri 4:00–5:30pm",
        activitiesTotal1: "Total no. of activities (a1)",
        activitiesTotal2: "Total no. of activities (a2)",
        schoolsTotal: "Total no. of schools",
        completedTotal: "Total (Completed)",
        inProgressTotal: "Total (In progress)",
        notCommencedTotal: "Total (Not yet commenced)",
        cancelledTotal: "Total (To be cancelled)",
        adjustmentTotal: "Total (Adjustment required)",
        activitiesCommunity:
            "(II) Activities open to the community (List out all the approved activities)",
        a1a2Total:
            "Aggregate of: (I)+(II) Total no. of approved activities = (a1)+(a2)",
        ngoType:
            "Name of NGO/Name of Department/Name of Subsidiary Organisation",
        ngoName: "Name of {{ngoType}}",
        ngoHeadType:
            "Head of NGO/Department/Subsidiary Organisation/Project Coordinator",
        ngoHeadTypeName: "Head of {{ngoType}}/Project Coordinator",
        ngoHeadName: "Name",
        ngoHeadPost: "Post",
        ngoHead: "Head of {{ngoType}}",
    },
    select: {
        ngoOption: {
            ngo: "NGO",
            department: "Department",
            subsidiaryOrganisation: "Subsidiary Organisation",
        },
        ngoHeadOption: {
            ngoHead: "Head of NGO/Department/Subsidiary Organisation",
            projectCoordinator: "Project Coordinator",
        },
    },
    errorMsg: {
        "E-0000": "Nominee Title is required [E-0000]",
        "E-0001": "Nominee Name is required [E-0001]",
        "E-0100": "Reward Nomination is required [E-0100]",
        "E-0101":
            "Contains English characters, spaces, dot, comma, hyphen and single quote. Numbers are not allowed.",
        "E-0102": "Chinese-only",
        "E-0103":
            "Must not be blank if Chinese Name in Chinese Commercial Code is not blank.",
        "E-0104": "Alphabets only",
        "E-0105": "Alpha-numeric only",
        "E-0106":
            "Contains Numeric characters and special characters which are space ( ), plus (+), hash (#), brackets (()) and hyphen (-).",
        "E-0107": "Numeric only",
        "E-0108":
            "Allow one decimal place. Contains Numeric characters and special characters which are space ( ), plus (+), hash (#), brackets (()), hyphen (-) and slash (/).",
        "E-0109": " Not match 20XX\\XX format",
        "E-0110": "The value is after the date of birth.",
        "E-0111": "Must have at least 1 file",
        "E-0112": "Must be no more than 2 files",
        "E-0113": "Not match HKID rules",
        "E-0114": "min 8 length",
        "E-0115": "max 20 length",
        "E-0116":
            "Special characters which are space ( ), plus (+), hash (#), brackets (()) and hyphen (-)",
        "E-0117":
            "Minimum length, Maximum length (default 100), Character type (alphabets only/alpha-numeric/Chinese-only), Pattern",
        "E-0118": "Please select at least 1 item",
        "E-0119": "This field must be at most {{number}} characters",
        "E-0120": "This field must be at least {{number}} characters",
    },
};
export default Form004EN;
